import {
  ICreateDownload,
  IDownload,
  CreateDownloadPayload,
} from '@zoomcatalog/design-system';
import api from '@/config/axios';

export default function useDownloadService() {
  const createDownload = (
    designId: string,
    format: string,
    payload: Partial<CreateDownloadPayload>
  ) =>
    api.post<ICreateDownload>(
      `project/${designId}/download/${format}`,
      payload
    );

  const updateDownload = (
    designId: string,
    jobId: string,
    payload: Partial<IDownload>
  ) => api.put<[]>(`project/${designId}/download/${jobId}`, payload);

  const getPendingDownloads = (designId: string) =>
    api.get<IDownload[]>(`project/${designId}/downloads/pending`);

  return {
    createDownload,
    updateDownload,
    getPendingDownloads,
  };
}
